import styled from 'styled-components'

export const Content = styled.p`
  padding: 16px 0;
  text-align: center;

  > span:first-child {
    font-weight: bold;
  }
`